import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 27 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M15.4 0C8.6-.2 3.1 5.3 3.1 12H.7c-.6 0-.9.7-.5 1.1l3.7 3.7c.3.3.7.3.9 0l3.7-3.7c.3-.3.3-.7 0-.9-.1-.1-.2-.2-.4-.2H5.7c0-5.2 4.2-9.4 9.5-9.3 5 .1 9.1 4.2 9.2 9.2.1 5.2-4.1 9.5-9.3 9.5-2.1 0-4.1-.7-5.7-2-.5-.4-1.3-.4-1.8.1-.6.5-.5 1.5.1 2 2.1 1.7 4.7 2.6 7.4 2.5 6.7 0 12.2-5.6 12-12.3C26.9 5.4 21.7.2 15.4 0m-.7 6.7c-.5 0-1 .5-1 1v4.9c0 .5.3.9.7 1.1l4.2 2.5c.5.3 1.1.1 1.4-.3.3-.5.1-1.1-.3-1.4l-3.8-2.3V7.7c-.2-.6-.6-1-1.2-1" }, null, -1)
  ])))
}
export default { render: render }